export interface FixedStepAdvanceResult {
  steps: number;
  alpha: number;
}

/**
 * Owns render-time debt without leaking a variable delta into gameplay.
 */
export class FixedStepDriver {
  private accumulator = 0;

  constructor(private readonly stepSeconds: number) {
    if (!Number.isFinite(stepSeconds) || stepSeconds <= 0) {
      throw new Error("Fixed step duration must be a positive finite number.");
    }
  }

  reset(): void {
    this.accumulator = 0;
  }

  advance(elapsedSeconds: number, step: () => void): FixedStepAdvanceResult {
    if (!Number.isFinite(elapsedSeconds) || elapsedSeconds < 0) {
      throw new Error("Elapsed time must be a non-negative finite number.");
    }

    this.accumulator += elapsedSeconds;
    let steps = 0;
    while (this.accumulator + Number.EPSILON >= this.stepSeconds) {
      step();
      this.accumulator -= this.stepSeconds;
      steps += 1;
    }
    if (Math.abs(this.accumulator) < Number.EPSILON) {
      this.accumulator = 0;
    }

    return {
      steps,
      alpha: this.interpolationAlpha(),
    };
  }

  interpolationAlpha(): number {
    return this.accumulator / this.stepSeconds;
  }
}
